import { useTranslation } from "hhn-commons";
import AlertHeaderWithDivider from "./AlertHeaderWithDivider";
import AlertsPanelHeader from "./AlertsPanelHeader";

const ReferralAlertHeader = ({ counter }: { counter: number }) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "chat" });
  return (
    <AlertHeaderWithDivider>
      <AlertsPanelHeader
        alertLabel={tNs("alerts.referral")}
        counter={counter}
      />
    </AlertHeaderWithDivider>
  );
};

export default ReferralAlertHeader;
